export default __webpack_public_path__ + "static/media/arrow-left-right-theme-color.92ce90c3.svg";